"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCampaignsRequest = exports.useCampaignsCountryEffect = void 0;

var _reactRedux = require("react-redux");

var _react = require("react");

var _campaigns = require("../store/campaigns/campaigns.actions");

var useCampaignsCountryEffect = function useCampaignsCountryEffect(countryId) {
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch((0, _campaigns.setCampaignsCountryId)(countryId));
  }, [countryId, dispatch]);
};

exports.useCampaignsCountryEffect = useCampaignsCountryEffect;

var useCampaignsRequest = function useCampaignsRequest(countryId, search) {
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch((0, _campaigns.loadCampaignsRequest)({
      countryId,
      search
    }));
  }, [dispatch, countryId, search]);
};

exports.useCampaignsRequest = useCampaignsRequest;